/**
 * @module MagnoliaHelpers
 */
const { addSmoothScrolling } = require('./addSmoothScrolling');
const {
  checkLogin,
  isAuthenticated,
  isOrganizationProfile,
  logout,
} = require('./checkLogin');
const { collectionTypeToPath } = require('./collectionTypeUtils');
const { findLastModifiedOnPage } = require('./findLastModifiedOnPage');
const { flattenObject } = require('./flattenObject');
const {
  generateAlbumSubtitle,
  generateAlbumSubtitleByMediaItem,
} = require('./generateAlbumSubtitle');
const { GenerateMagnoliaPageJSON } = require('./GenerateMagnoliaPageJSON');
const {
  getAPIBase,
  isMagnoliaAuthor,
  isMagnoliaPublic,
} = require('./getAPIBase');
const { getHashedIds } = require('./getHashedIds');
const {
  addWorkspaceToItems,
  getMagnoliaItem,
  getWorkspace,
} = require('./getMagnoliaItem');
const { getMgnlBase } = require('./getMgnlBase');
const { getRouterBasename } = require('./getRouterBasename');
const {
  checkIfIsImgixUrl,
  convertS3DamItems,
  convertToCmsAssetUrl,
  getLogoPathBasedOnCollectionType,
  replaceMagnoliaAssetsToImgix,
} = require('./imgix');
const { getLabelList, getLabelValue, getLabelValueV2 } = require('./labels');
const {
  changeLanguage,
  getCurrentLanguage,
  getLanguages,
  removeCurrentLanguage,
} = require('./languages');
const { mediaTypeToPath, mediaUrlFromType } = require('./mediaTypeUtils');
const { normalizeContentList } = require('./normalizeContentList');
const { rectifyMediaCollectionType } = require('./rectifyMediaCollectionType');
const {
  mediaTypeFromUuid,
  sortDateBased,
  sortEpisodeBased,
  sortMedia,
  uuidFromMediaType,
} = require('./sortMediaItem');
const {
  addFingerprintToUrl,
  addParamsToUrl,
  escapeUrl,
  getFingerprint,
  getUrlStructureByData,
  getUrlStructureByPath,
  stringToSlug,
} = require('./urls');

module.exports = {
  addFingerprintToUrl,
  addParamsToUrl,
  addSmoothScrolling,
  addWorkspaceToItems,
  changeLanguage,
  checkIfIsImgixUrl,
  checkLogin,
  collectionTypeToPath,
  convertS3DamItems,
  convertToCmsAssetUrl,
  escapeUrl,
  findLastModifiedOnPage,
  flattenObject,
  generateAlbumSubtitle,
  generateAlbumSubtitleByMediaItem,
  GenerateMagnoliaPageJSON,
  getAPIBase,
  getCurrentLanguage,
  getFingerprint,
  getHashedIds,
  getLabelList,
  getLabelValue,
  getLabelValueV2,
  getLanguages,
  getLogoPathBasedOnCollectionType,
  getMagnoliaItem,
  getMgnlBase,
  getRouterBasename,
  getUrlStructureByData,
  getUrlStructureByPath,
  getWorkspace,
  isAuthenticated,
  isMagnoliaAuthor,
  isMagnoliaPublic,
  isOrganizationProfile,
  logout,
  mediaTypeFromUuid,
  mediaTypeToPath,
  mediaUrlFromType,
  normalizeContentList,
  rectifyMediaCollectionType,
  removeCurrentLanguage,
  replaceMagnoliaAssetsToImgix,
  sortDateBased,
  sortEpisodeBased,
  sortMedia,
  stringToSlug,
  uuidFromMediaType,
};
